import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/Primitives";
import { LIFECYCLE } from "@/lib/content";

export const Lifecycle = () => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 60%"] });
  const pathLength = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section ref={ref} className="section-py bg-[color:var(--bp-bg-2)]" data-testid="lifecycle-visual-section">
      <div className="container-bp">
        <SectionHeading
          align="center"
          eyebrow="From hire to retire"
          title="The full talent lifecycle, designed as one continuous relationship."
          intro="Most firms place and disappear. We stay — because your people's potential goes far beyond their first day."
        />

        <div className="relative mt-16">
          {/* Connector line (desktop) */}
          <svg className="absolute left-0 top-[46px] hidden h-2 w-full md:block" viewBox="0 0 1000 4" preserveAspectRatio="none" aria-hidden>
            <line x1="40" y1="2" x2="960" y2="2" stroke="#144970" strokeWidth="2" />
            <motion.line
              x1="40" y1="2" x2="960" y2="2" stroke="#2DB5A5" strokeWidth="2"
              style={reduce ? { pathLength: 1 } : { pathLength }}
            />
          </svg>

          <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-6">
            {LIFECYCLE.map((node, i) => (
              <Reveal key={node.step} delay={i * 0.12}>
                <div className="group relative flex flex-col items-center text-center">
                  <span className="relative z-10 flex h-[92px] w-[92px] items-center justify-center rounded-full border border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] font-display text-2xl font-semibold text-[color:var(--bp-gold)] transition-all duration-300 group-hover:border-[color:var(--bp-teal)] group-hover:shadow-[0_0_0_6px_rgba(45,181,165,0.12)]">
                    {node.step}
                  </span>
                  <h3 className="mt-6 font-display text-xl font-semibold text-[color:var(--bp-cream)]">{node.title}</h3>
                  <p className="mt-3 max-w-xs text-[14px] leading-relaxed text-[color:var(--bp-text-muted)]">{node.desc}</p>
                  <ul className="mt-5 flex flex-wrap justify-center gap-2">
                    {node.deliverables.map((d) => (
                      <li key={d} className="rounded-full border border-[color:var(--bp-border)] bg-[color:var(--bp-bg)] px-3 py-1 text-[11px] text-[color:var(--bp-text-muted)]">{d}</li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
